import React, { useEffect, useState } from "react";
import Table from 'react-bootstrap/Table';
import '../projects/scss/task.scss'
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from "react-redux";
import SelectInput from "../../components/inputs/select";
import MultiSelect from "../../components/inputs/multi-select";
import idx from "idx";
import { allocateSchedule } from "../../actions/timesheet.action";
import { getProject, getProjectList, getTaskdropdownData } from "../../actions/project-management.action";
import _ from 'lodash';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import { differenceInHours, format } from "date-fns";
import { sortByKeyAsc } from "src/util/common";
import { convertToReactSelectFormat, filterLockedSections } from "../../util/section-dropdown-format";
import { TIMESHEET_TASK_DROPDOWN_PARAMS } from "./task-dropdown-options";

export default function ScheduleAllocateResource({ show, handleClose, handleSubmit, userData = [], allocations = {}, ...props }) {

    const dispatch = useDispatch();
    const user = useSelector(state => state.user.userData);
    const projectCategories = useSelector(state => state.project.projectCategories)
    const [fields, setFields] = useState({
        projectType: {
            name: 'projectType',
            placeholder: 'Select Project Type',
            type: 'select',
            items: [],
            value: ''
        },
        projectId: {
            name: 'projectId',
            placeholder: 'Select Project',
            type: 'select',
            items: [],
            value: ''
        },
        task: {
            name: 'task',
            type: 'multiselect',
            value: null,
            items: [],
            label: 'Select Task',
            placeholder: 'Select Task',
            error: false,
            valid: true,
            touched: false,
            isSearchable: true,
            isMulti: false,
            validation: []
        },
        items: {
            projects: [],
            tasks: {}
        }
    })
    const [data, setData] = useState([])
    const [showDetail, setShowDetail] = useState('');
    const [showView, setShowView] = useState('');
    const [detail, setDetail] = useState({});
    const [viewData, setViewData] = useState({});
    const [selectedTaskId, setSelectedTaskId] = useState(null);

    useEffect(() => {
        init();
    }, [])

    const init = async () => {
        let projectType = [];
        let permissions = user && user.permissions;

        let list = await dispatch(getProjectList(null, 'PROJECT', null)).catch(e => console.error(e))
        list = (Array.isArray(list) &&
            list.filter(project => project.status === 'IN_PROGRESS').map(_ => ({ key: _.name, value: _.id, type: _.projectType }))) || [];
        list = sortByKeyAsc(list);
        let projects = []

        for await (const item of projectCategories) {
            if (permissions[`projectManagement${item.type}`] > 0 || (user.global_user && user.selected_account.id)) {
                projectType.push({
                    key: item.name,
                    value: item.type
                })
                projects.push(...list.filter(_list => _list.type == item.type))
            }
        }
        projects = sortByKeyAsc(projects);
        setFields(prev => ({
            ...prev,
            projectType: { ...prev.projectType, items: projectType },
            items: {
                ...prev.items,
                projects: projects,
            }
        }));
        if (!data.length) {
            let _data = userData.map(user => {
                let _allocations = new Set();
                let days = new Set(), hours = 0, leave = new Set(), conflicts = new Set();
                (allocations[user.value] || []).map(allocation => {
                    if ((user.dates || []).includes(allocation.allocationId)) {
                        if (allocation.allocationId.startsWith('tmp-')) {
                            hours += Math.abs(differenceInHours(allocation.start, allocation.end))
                            allocation.type = 'WORK';
                        }
                        days.add(format(allocation.start, 'yyyy-MM-dd'))
                        if (allocation.type == 'LEAVE') {
                            leave.add(allocation)
                        } else if (allocation.type == 'WORK' && !allocation.allocationId.startsWith('tmp-')) {
                            conflicts.add(allocation)
                        }
                        _allocations.add(allocation)
                    }
                })
                return {
                    ...user,
                    allocations: [..._allocations],
                    days: [...days],
                    hours,
                    cost: Number(hours) * Number(user.rate),
                    leave: [...leave],
                    conflicts: [...conflicts]
                }
            })
            setData(_data)
        }
    }

    const updateData = (_temp = [], { projectId, taskId }, prevProject, prevTask) => {
        let _data = _temp.map(user => {
            let { allocations = [] } = user;
            let days = new Set(), hours = 0, leave = new Set(), conflicts = new Set();
            allocations = allocations.map(allocation => {
                days.add(format(allocation.start, 'yyyy-MM-dd'))
                if (allocation.type == 'LEAVE') {
                    leave.add(allocation)
                } else if (allocation.type == 'WORK') {
                    if (allocation.allocationId.startsWith('tmp-')) {
                        hours += Math.abs(differenceInHours(allocation.start, allocation.end))
                    } else {
                        conflicts.add(allocation)
                    }
                    if (allocation.allocationId.startsWith('tmp-')) {
                        if (projectId) {
                            let project = (idx(fields, _ => _.items.projects) || []).find(item => item.value == projectId) || {}
                            allocation.projectId = projectId;
                            allocation.projectType = project.type;
                            allocation.taskId = ''
                        }
                        if (taskId) {
                            allocation.taskId = taskId;
                        }
                    }
                }
                return allocation;
            })
            return {
                ...user,
                allocations: allocations,
                days: [...days],
                hours,
                cost: Number(hours) * Number(user.rate),
                leave: [...leave],
                conflicts: [...conflicts]
            }
        })
        setData(_data)
    }

    useEffect(() => {

    }, [data])

    const handleProjectChange = async (value, skip = false) => {
        const response = await dispatch(getTaskdropdownData(value, TIMESHEET_TASK_DROPDOWN_PARAMS));
        const historicalSelectionIds = data.flatMap((userItem) =>
            (userItem.allocations || []).flatMap((allocation) => [
                allocation.taskId,
                allocation.stageId,
            ]).filter(Boolean)
        );
        const filteredData = filterLockedSections(response || [], historicalSelectionIds);
        const formatted = convertToReactSelectFormat(filteredData, null, true);

        setFields(prev => {
            const newFields = _.cloneDeep(prev);
            if (!skip) {
                newFields.projectId.value = value;
                newFields.task.value = null;
            }
            newFields.task.items = formatted;

            // Cache the task list for the project
            if (!newFields.items.tasks) newFields.items.tasks = {};
            newFields.items.tasks[value] = formatted;

            if (selectedTaskId && !newFields.task.value) {
                const matched = formatted.find(item => item.value === selectedTaskId);
                newFields.task.value = matched || null;
            }

            return newFields;
        });
    }

    const inputChangeHandler = (value, type) => {
        setFields(prev => ({
            ...prev,
            [type]: { ...prev[type], value: value },
        }));
    }

    const detailChangeHandler = async (index, name, value) => {
        let _allocations = _.cloneDeep(detail.allocations)
        _allocations[index][name] = value;
        if (name == 'type' && value == 'LEAVE') {
            _allocations[index]['projectId'] = '';
            _allocations[index]['projectType'] = '';
            _allocations[index]['taskId'] = '';
        } else if (name == 'projectId') {
            // Fetch tasks for this project
            const response = await dispatch(getTaskdropdownData(value, TIMESHEET_TASK_DROPDOWN_PARAMS));
            const historicalSelectionIds = [_allocations[index]?.taskId, _allocations[index]?.stageId].filter(Boolean);
            const filteredData = filterLockedSections(response || [], historicalSelectionIds);
            const formatted = convertToReactSelectFormat(filteredData, null, true);

            setFields(prev => ({
                ...prev,
                items: {
                    ...prev.items,
                    tasks: {
                        ...prev.items.tasks,
                        [value]: formatted
                    }
                }
            }));

            let project = (idx(fields, _ => _.items.projects) || []).find(item => item.value == value) || {}
            _allocations[index]['projectType'] = project?.type || _allocations[index]['projectType'];
            _allocations[index]['taskId'] = '';
        } else if (name == 'taskId') {
            const projectId = _allocations[index]['projectId'];
            const tasks = idx(fields, _ => _.items.tasks[projectId]) || [];
            const selectedTask = tasks.find(item => item.value === value);
            if (selectedTask) {
                _allocations[index]['taskId'] = value;
                _allocations[index]['taskName'] = selectedTask.label
            }
        }
        setDetail(prev => ({
            ...prev,
            allocations: _allocations
        }));
    }

    const submitData = () => {
        let user = []
        for (const item of data) {
            let works = item.allocations.filter(item => item.type == 'WORK')
            let leaves = item.allocations.filter(item => item.type == 'LEAVE')
            user.push({
                id: item.value,
                leaves: leaves.map(leave => {
                    return {
                        id: leave.allocationId.startsWith('tmp-') ? '' : leave.allocationId,
                        startTime: format(leave.start, "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
                        endTime: format(leave.end, "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
                        type: 'LONG_TERM',
                        previousType: leave.previousType || '',
                    }
                }),
                allocations: works.map(work => {
                    // Find the corresponding task if it exists
                    let selectedTask = (idx(fields, _ => _.items.tasks[work.projectId]) || []).find(t => t.value === work.taskId);
                    if (!selectedTask && fields.projectId.value == work.projectId) {
                        selectedTask = fields.task.items.find(item => item.value === work.taskId);
                    }

                    const isStage = selectedTask?.isStage;

                    return {
                        id: work.allocationId.startsWith('tmp-') ? '' : work.allocationId,
                        projectId: work.projectId,
                        projectType: work.projectType,
                        stageId: isStage ? (selectedTask.value) : '',
                        taskId: isStage ? '' : (idx(selectedTask, _ => _.value) || work.taskId || ''),
                        taskType: idx(selectedTask, _ => _.taskType) || (work.type === 'WORK' ? 'TASK' : 'LEAVE') || '',
                        taskName: idx(selectedTask, _ => _.label) || idx(selectedTask, _ => _.key) || work.taskName || '',
                        startTime: format(work.start, "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
                        endTime: format(work.end, "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
                        allDayWithBreaks: true,
                        hourlyRate: Number(item.rate),
                        previousType: work.previousType || '',
                    }
                }),
            })
        }

        dispatch(allocateSchedule({ users: user })).then(data => {
            if (handleSubmit) {
                handleSubmit()
            } else {
                handleClose()
            }
        }).catch(e => console.error(e))
    }

    return (
        <>
            <Modal show={show} onHide={handleClose} size="xl" centered>
                <Modal.Header closeButton className="border-0 modal-top-header-info">
                    <div className="d-flex w-100 header-content">
                        <h2 className="my-auto">Confirm Allocations</h2>
                        {/* <button type="submit" class=" secondarybtn secondarybtn-outline btn-ch ms-auto btn btn-primary">Project</button>
                         <button type="submit" class="secondarybtn secondarybtn-outline btn-ch ms-2 btn btn-primary">Task</button> */}
                    </div>
                </Modal.Header>
                <Modal.Body className="pt-0">
                    <div className="material-list-block mt-0">
                        <div className="table-responsive">
                            <Table bordered className="table-create table-material table-material-ch">
                                <thead>
                                    <tr>
                                        <th className="w-auto"></th>
                                        <th className="w-auto">Day</th>
                                        <th>Hours</th>
                                        <th>Cost</th>
                                        <th>Leave</th>
                                        <th>Conflicts</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map(item => {
                                        return (
                                            <tr key={item.value}>
                                                <td>{item.key}</td>
                                                <td>{(item.days || []).length}</td>
                                                <td>{item.hours || 0}</td>
                                                <td>${item.cost || 0} </td>
                                                <td>
                                                    <span className="allocation-table-status leave">
                                                        {(item.leave || []).length}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="allocation-table-status conflicts">
                                                        {(item.conflicts || []).length}
                                                    </span>
                                                </td>
                                                <td className="text-center action-icons-task">
                                                    {/* <VisibilityIcon
                                                        className="view-icon"
                                                        onClick={() => {
                                                            setShowView(item.value)
                                                            setViewData(item)
                                                        }} 
                                                        title="View Allocations"
                                                    /> */}
                                                    <EditIcon
                                                        className="edit-icon"
                                                        onClick={() => {
                                                            setShowDetail(item.value)
                                                            setDetail(item)
                                                        }}
                                                        title="Edit Allocations"
                                                    />
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="project-task-dropdown">
                            <div className="row">
                                <div className="col-lg-4">
                                    <SelectInput
                                        {...fields.projectId}
                                        items={idx(fields, _ => _.items.projects) || []}
                                        onChange={(e) => {
                                            updateData(data, { projectId: e.target.value }, fields.projectId.value, '')
                                            handleProjectChange(e.target.value)
                                        }}
                                    />
                                </div>
                                <div className="col-lg-5">
                                    <MultiSelect
                                        {...fields.task}
                                        isStage={true}
                                        onChangeHandler={(value) => {
                                            const taskId = idx(value, _ => _.value) || '';
                                            setSelectedTaskId(taskId);
                                            updateData(data, { taskId }, '', fields.task.value?.value || '');
                                            inputChangeHandler(value, 'task');
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="d-flex w-auto mt-auto ms-auto">
                            {(() => {
                                const hasCompleteIndividualAllocations = data.every(user =>
                                    user.allocations
                                        .filter(allocation => allocation.type === 'WORK' && allocation.allocationId.startsWith('tmp-'))
                                        .every(allocation => allocation.projectId && allocation.taskId)
                                );

                                const shouldShowConfirm = fields.projectId.value || hasCompleteIndividualAllocations;

                                return shouldShowConfirm && (
                                    <button onClick={submitData} class="ms-auto me-3 secondarybtn btn btn-primary">
                                        CONFIRM
                                    </button>
                                );
                            })()}
                            <button onClick={handleClose} class="secondarybtn cancelbtn me-auto btn btn-primary">CANCEL</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* View-Only Modal */}
            {showView && <Modal show={showView} size="xl" onHide={() => setShowView('')}>
                <Modal.Header closeButton className="border-0 modal-top-header-info">
                    <div className="d-flex w-100 header-content">
                        <h2 className="my-auto">View Allocations - {viewData.key}</h2>
                    </div>
                </Modal.Header>
                <Modal.Body className="pt-0">
                    <div className="material-list-block mt-0">
                        <div className="table-responsive">
                            <Table bordered className="table-create table-material w-100">
                                <thead>
                                    <tr>
                                        <th className="w-auto">Date</th>
                                        <th>Allocation Type</th>
                                        <th>Project</th>
                                        <th>Task</th>
                                        <th>Status</th>
                                        <th className="w-auto">Reason</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(() => {
                                        // Filter out incomplete temporary allocations
                                        const meaningfulAllocations = (idx(viewData, _ => _.allocations) || []).filter(allocation => {
                                            // Show leave allocations
                                            if (allocation.type === 'LEAVE') return true;

                                            // Show existing (non-temporary) work allocations
                                            if (allocation.type === 'WORK' && !allocation.allocationId.startsWith('tmp-')) return true;

                                            // Show temporary work allocations only if they have project and task assigned
                                            if (allocation.type === 'WORK' && allocation.allocationId.startsWith('tmp-')) {
                                                return allocation.projectId && allocation.taskId;
                                            }

                                            return false;
                                        });

                                        if (meaningfulAllocations.length === 0) {
                                            return (
                                                <tr>
                                                    <td colSpan="6" className="text-center py-4">
                                                        <em>No allocations yet</em>
                                                    </td>
                                                </tr>
                                            );
                                        }

                                        return meaningfulAllocations.map((allocation, index) => {
                                            const projectName = (idx(fields, _ => _.items.projects) || []).find(p => p.value === allocation.projectId)?.key || allocation.projectId || '-';
                                            const taskName = allocation.taskName || allocation.taskId || '-';

                                            return (<tr key={`view-${index}`}>
                                                <td>{format(allocation.start, 'dd/MM/yyyy')} {format(allocation.start, 'hh:mm a')} - {format(allocation.end, 'hh:mm a')}</td>
                                                <td>{allocation.type === 'WORK' ? 'Work' : 'Leave'}</td>
                                                <td>{allocation.type === 'LEAVE' ? '-' : projectName}</td>
                                                <td>{allocation.type === 'LEAVE' ? '-' : taskName}</td>
                                                <td>{allocation.display}</td>
                                                <td>{allocation.allocationId.startsWith('tmp-') ? '' : allocation.previousType}</td>
                                            </tr>)
                                        });
                                    })()}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div class="d-flex w-auto mt-auto ms-auto">
                            <button
                                onClick={() => setShowView('')}
                                class="ms-auto me-3 secondarybtn btn btn-primary"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>}

            {/* Edit Modal */}
            {showDetail && <Modal show={showDetail} size="xl" onHide={() => setShowDetail('')}>
                <Modal.Header closeButton className="border-0 modal-top-header-info">
                    <div className="d-flex w-100 header-content">
                        <h2 className="my-auto">Details</h2>
                    </div>
                </Modal.Header>
                <Modal.Body className="pt-0">
                    <div className="material-list-block mt-0">
                        <div className="table-responsive">
                            <Table bordered className="table-create table-material w-100">
                                <thead>
                                    <tr>
                                        <th className="w-auto">Date</th>
                                        <th>Allocation Type</th>
                                        <th>Project</th>
                                        <th>Task</th>
                                        <th>Status</th>
                                        <th className="w-auto">Reason</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(idx(detail, _ => _.allocations) || []).map((allocation, index) => {

                                        return (<tr key={`detail-${index}`}>
                                            <td>{format(allocation.start, 'dd/MM/yyyy')} {format(allocation.start, 'hh:mm a')} - {format(allocation.end, 'hh:mm a')}</td>
                                            <td>
                                                <SelectInput
                                                    className="input-block-sm"
                                                    placeholder='Select Allocation Type'
                                                    items={[
                                                        { key: 'Work', value: 'WORK' },
                                                        { key: 'Leave', value: 'LEAVE' }
                                                    ]}
                                                    value={allocation.type}
                                                    onChange={(e) => detailChangeHandler(index, 'type', e.target.value)}
                                                />
                                            </td>
                                            <td className='w-20'>
                                                <SelectInput
                                                    className="input-block-sm"
                                                    placeholder='Select Project'
                                                    value={allocation.projectId}
                                                    items={idx(fields, _ => _.items.projects) || []}
                                                    disabled={allocation.type == 'LEAVE' ? true : false}
                                                    onChange={(e) => detailChangeHandler(index, 'projectId', e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <MultiSelect
                                                    className="input-block-sm"
                                                    placeholder='Select Task'
                                                    isStage={true}
                                                    dropdownWidth='150%'
                                                    value={allocation.taskId ? (idx(fields, _ => _.items.tasks[allocation.projectId]) || []).find(item => item.value === allocation.taskId) : null}
                                                    items={idx(fields, _ => _.items.tasks[allocation.projectId]) || []}
                                                    disabled={allocation.type == 'LEAVE' ? true : false}
                                                    isMulti={false}
                                                    isSearchable={true}
                                                    onChangeHandler={(value) => detailChangeHandler(index, 'taskId', idx(value, _ => _.value) || '')}
                                                />
                                            </td>
                                            <td>{allocation.display}</td>
                                            <td>{allocation.allocationId.startsWith('tmp-') ? '' : allocation.previousType}</td>
                                        </tr>)
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div class="d-flex w-auto mt-auto ms-auto">
                            <button
                                onClick={() => {
                                    let _data = data.map(user => {
                                        if (user.value == showDetail) user.allocations = idx(detail, _ => _.allocations) || []
                                        return user;
                                    })
                                    setData(_data)
                                    setShowDetail('')
                                    updateData(_data, {})
                                }}
                                class="ms-auto me-3 secondarybtn btn btn-primary"
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>}
        </>
    );

}
